import { useEffect, useRef } from 'react';
import type { RefObject } from 'react';

function isHeaderWheelScroll(event: WheelEvent, wrapper: HTMLElement): boolean {
    const target = event.target as HTMLElement;
    if (!target.closest('thead')) return false;
    if (event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY))
        return false;
    return wrapper.scrollWidth > wrapper.clientWidth;
}

export function useHeaderWheelScroll<T extends HTMLElement>(): RefObject<T> {
    const wrapperRef = useRef<T>(null);
    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) return undefined;

        const handleWheel = (event: WheelEvent): void => {
            if (!isHeaderWheelScroll(event, wrapper)) return;
            event.preventDefault();
            wrapper.scrollLeft += event.deltaY;
        };
        wrapper.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            wrapper.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return wrapperRef;
}
